'use client'

import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { storyblokEditable } from '@storyblok/react'
import { ProductButtonItemBlock, type ProductButtonItemBlockProps } from './ProductButtonItemBlock'
import { scrollerContent, scrollerItem, scrollerPlatter } from './ProductButtonsBlock.css'

export type ProductButtonsBlockProps = SbBaseBlockProps<{
  items: ExpectedBlockType<ProductButtonItemBlockProps>
}>

export const ProductButtonsBlock = ({ blok }: ProductButtonsBlockProps) => {
  const items = filterByBlockType(blok.items, ProductButtonItemBlock.blockName)

  if (items.length === 0) {
    return null
  }

  return (
    <div className={scrollerContent} {...storyblokEditable(blok)}>
      <ul className={scrollerPlatter}>
        {items.map((nestedBlock) => (
          <li key={nestedBlock._uid} className={scrollerItem}>
            <ProductButtonItemBlock blok={nestedBlock} />
          </li>
        ))}
      </ul>
    </div>
  )
}
ProductButtonsBlock.blockName = 'productButtons'
